import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var HierarchyIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.143,12c0.002,0 0.857,0.021 0.857,1c0,0.98 -0.857,1 -0.857,1l-10.286,0c0,0 -0.857,-0.014 -0.857,-1c0,-0.985 0.855,-1 0.857,-1l10.286,0Z M14.143,8c0.002,0 0.857,0.021 0.857,1c0,0.979 -0.855,1 -0.857,1l-10.286,0c0,0 -0.857,-0.014 -0.857,-1c0,-0.985 0.855,-1 0.857,-1l10.286,0Z M12.143,4c0.002,0 0.857,0.021 0.857,1c0,0.979 -0.855,1 -0.857,1l-10.286,0c0,0 -0.857,-0.014 -0.857,-1c0,-0.985 0.855,-1 0.857,-1l10.286,0Z"
  }));
});
HierarchyIcon.displayName = 'HierarchyIcon';
export default HierarchyIcon;